<template>
    <div class="accountplan">
        <PageTitle icon="fa fa-clone" main="Registro" sub="Plano de Contas" />

        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input id="accountplan-id" type="hidden" v-model="accountplan.id" />
            <b-row class="mt-2">
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Conta Contábil:"
                        label-for="accountplan-internal_code_account_plan"
                    >
                        <b-form-input
                            id="accountplan-internal_code_account_plan"
                            type="text"
                            size="sm"
                            ref="inputFocus"
                            v-model="accountplan.internal_code_account_plan"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Código da Conta..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="5" sm="12">
                    <b-form-group
                        label="Descrição:"
                        label-for="accountplan-name_account_plan"
                    >
                        <b-form-input
                            id="accountplan-name_account_plan"
                            type="text"
                            v-model="accountplan.name_account_plan"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Descrição Contábil..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Natureza Contábil:"
                        label-for="accountplan-nature_account"
                    >
                        <b-form-input
                            id="accountplan-nature_account"
                            type="text"
                            v-model="accountplan.nature_account"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Natureza (D | C)..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group
                        v-if="mode === 'save' || mode === 'read'"
                        label="Conta Controle:"
                        label-for="accountplan-control_account_id"
                    >
                        <b-form-select
                            id="accountplan-control_account_id"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="controlaccounts"
                            v-model="accountplan.control_account_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Código Reduzido:"
                        label-for="accountplan-small_code"
                    >
                        <b-form-input
                            id="accountplan-small_code"
                            type="text"
                            size="sm"
                            v-model="accountplan.small_code"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Código Reduzido..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group label="Nível:" label-for="accountplan-degree">
                        <b-form-input
                            id="accountplan-degree"
                            v-model="accountplan.degree"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            type="number"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="accountplan.synthetic"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="accountplan-synthetic"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="accountplan-synthetic"
                            >
                                Sintético?
                            </label>
                        </div>
                    </div>
                </b-col>

                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="accountplan.blocked"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="accountplan-blocked"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="accountplan-blocked"
                            >
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-form>
        <hr v-show="mode === 'save'" />
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2  mb-2 fa fa-plus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-reply"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 mb-2 ml-2 fa"
                    :class="icon"
                    @click="
                        ;[
                            loadAccountPlans(),
                            toggleBusy(),
                            (showTable = !showTable),
                        ]
                    "
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <br />
        <div class="col-sm-6">
            <div class="form-group">
                <input
                    type="text"
                    size="sm"
                    icon="search"
                    v-model="search"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    placeholder="Informe a Descrição/Conta Contábil"
                    class="form-control mb-2"
                />
                <b-form-select
                    id="control_account_id"
                    @input="loadAccountPlans"
                    size="sm"
                    :options="controlaccounts"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    v-model="control_account_id"
                    class="mb-2"
                />
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Sintético"
                            v-slot="{ ariaDescribedby }"
                        >
                            <b-form-radio-group
                                v-model="synthetic"
                                :options="questionBox"
                                name="synthetic"
                                :aria-describedby="ariaDescribedby"
                                @input="loadAccountPlans"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Bloqueado"
                            v-slot="{ ariaDescribedby }"
                        >
                            <b-form-radio-group
                                v-model="blocked"
                                :options="questionBox"
                                name="blocked"
                                :aria-describedby="ariaDescribedby"
                                @input="loadAccountPlans"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-button
                            size="lq"
                            title="Limpar Consulta"
                            variant="light"
                            class="mt-2 mb-2 ml-2 fa fa-eraser"
                            @click="eraserFilter"
                        >
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </div>

        <transition name="slide" type="animation" appear>
            <b-table
                :busy="isBusy"
                class="table-responsive"
                v-show="showTable"
                hover
                key="slide"
                head-variant="light"
                :per-page="perPage"
                :current-page="currentPage"
                :items="filteredList"
                :fields="fields"
            >
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button
                        title="Detalhe do registro"
                        size="sm"
                        variant="light"
                        @click="loadAccountPlan(data.item, 'read')"
                        class="mr-2 mt-2"
                    >
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button
                        title="Editar registro"
                        size="sm"
                        variant="light"
                        @click="loadAccountPlan(data.item)"
                        class="mr-2 mt-2"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        title="Excluir registro"
                        size="sm"
                        variant="light"
                        @click="loadAccountPlan(data.item, 'remove')"
                        class="mr-2 mt-2"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
        </transition>
        <transition name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
        </transition>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

export default {
    name: 'AccountPlan',
    components: { PageTitle },
    data: function() {
        return {
            mode: 'insert',
            search: '',
            degree_id: '',
            control_account_id: null,
            synthetic: null,
            blocked: null,
            accountplan: {},
            accountplans: [],
            controlaccounts: [],
            accountsynthetics: [],
            showTable: false,
            isBusy: false,
            perPage: 5,
            currentPage: 1,
            fields: [
                {
                    key: 'internal_code_account_plan',
                    label: 'Conta Contábil',
                    sortable: true,
                },
                {
                    key: 'name_account_plan',
                    label: 'Descrição',
                    sortable: true,
                    variant: 'secondary',
                },
                {
                    key: 'small_code',
                    label: 'Código Reduzido',
                    sortable: false,
                },
                {
                    key: 'synthetic',
                    label: 'Sintético',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não'),
                },
                { key: 'nature_account', label: 'Natureza', sortable: false },
                {
                    key: 'name_control_account',
                    label: 'Conta Controle',
                    sortable: false,
                },
                { key: 'degree', label: 'Grau', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não'),
                },
                { key: 'actions', label: 'Ações', variant: 'light' },
            ],
            questionBox: [
                { text: 'Sim', value: 1 },
                { text: 'Não', value: 0 },
            ],
        }
    },
    computed: {
        filteredList() {
            return this.accountplans.filter(accountplan => {
                return (
                    accountplan.internal_code_account_plan
                        .toLowerCase()
                        .includes(this.search.toLowerCase()) ||
                    accountplan.name_account_plan
                        .toLowerCase()
                        .includes(
                            this.search.toLowerCase() ||
                                accountplan.internal_code_account_plan
                                    .toLowerCase()
                                    .includes(this.degree_id.toLowerCase())
                        )
                )
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.accountplans.length
        },
    },
    methods: {
        async loadAccountPlans() {
            const url = `${baseApiUrl}/accountplans/?control_account_id=${this.control_account_id}&synthetic=${this.synthetic}&blocked=${this.blocked}`
            await axios.get(url).then(res => {
                this.accountplans = res.data
                this.isBusy = false
            })
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        async loadAccountPlanSynthetic() {
            const url = `${baseApiUrl}/accountplansynthetic`
            await axios.get(url).then(res => {
                this.accountsynthetics = res.data
            })
        },
        async reset() {
            this.mode = 'insert'
            await this.loadAccountPlans()
        },
        alterModo() {
            this.mode = 'save'
            this.accountplan = {}
            this.$refs.inputFocus.focus()
        },
        async save() {
            const method = this.accountplan.id ? 'put' : 'post'
            const id = this.accountplan.id ? `/${this.accountplan.id}` : ''
            await axios[method](
                `${baseApiUrl}/accountplans${id}`,
                this.accountplan
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async remove() {
            const id = this.accountplan.id
            await axios
                .delete(`${baseApiUrl}/accountplans/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadAccountPlan(accountplan, mode = 'save') {
            this.mode = mode
            this.accountplan = { ...accountplan }
        },
        async loadControlAccount() {
            const url = `${baseApiUrl}/controlaccounts`
            await axios.get(url).then(res => {
                this.controlaccounts = res.data.map(controlaccount => {
                    return {
                        value: controlaccount.id,
                        text: controlaccount.name_control_account,
                    }
                })
            })
        },
        actionNewAccountPlan(accountplan, mode = 'save') {
            this.mode = mode
            const sizearr = accountplan.internal_code_account_plan.length
            if (sizearr === 2) {
                let arr = accountplan.internal_code_account_plan.substring(0, 2)
                if (parseInt(arr).length === 2) {
                    this.accountplan.internal_code_account_plan =
                        parseInt(arr) + 1
                } else {
                    this.accountplan.internal_code_account_plan =
                        '0' + (parseInt(arr) + 1)
                }
            }
            if (sizearr === 5) {
                let arr = accountplan.internal_code_account_plan.substring(4, 5)
                if (parseInt(arr).length === 2) {
                    this.accountplan.internal_code_account_plan =
                        accountplan.internal_code_account_plan.substring(0, 2) +
                        (parseInt(arr) + 1)
                } else {
                    this.accountplan.internal_code_account_plan =
                        accountplan.internal_code_account_plan.substring(0, 4) +
                        (parseInt(arr) + 1)
                }
            }
            if (sizearr === 8) {
                let arr = accountplan.internal_code_account_plan.substring(7, 8)
                if (parseInt(arr).length === 2) {
                    this.accountplan.internal_code_account_plan =
                        accountplan.internal_code_account_plan.substring(0, 4) +
                        (parseInt(arr) + 1)
                } else {
                    this.accountplan.internal_code_account_plan =
                        accountplan.internal_code_account_plan.substring(0, 7) +
                        (parseInt(arr) + 1)
                }
            }
        },
        eraserFilter() {
            this.control_account_id = null
            this.blocked = null
            this.synthetic = null
            this.search = ''
        },
    },
    async mounted() {
        await this.loadControlAccount()
        await this.loadAccountPlans()
        await this.loadAccountPlanSynthetic()
        this.showTable = true
    },
}
</script>

<style>
.accountplan {
    font-size: 0.7rem;
}

.accountplan input {
    font-size: 0.7rem;
}

.accountplan button {
    font-size: 0.7rem;
}

.accountplan select {
    font-size: 0.7rem;
}

.accountplan form,
label,
table {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
